import Utils from '@/utils/utils';
import { useRef, useEffect, useState, useMemo } from 'react';
import Modal from '@/components/Modal';
import classNames from 'classnames';
import raysserveapi from '@/api/raysserveapi';
import { Button, Space, Tooltip, Input, message, Form } from '@/components/AntD';
import Table, { setColumn } from '@/components/Table/Table';
import { useRequest, useDebounceFn } from 'ahooks';
import DragUpload from '@/components/DragUpload';
import './index.scss';
export default function phraseModal(props) {
  const { phraseModalVisible, changePhraseModalVisible } = props;
  const [form] = Form.useForm();
  const [editRow, setEditRow] = useState({});
  const [addPhraseVisible, setAddPhraseVisible] = useState(false);
  const [words, setWords] = useState('');
  const [importLoading, setImportLoading] = useState(false);

  const importUpload = useRef(null);
  const inputRef = useRef(null);
  const searchOptions = useRef({
    currentPage: 0,
    numPerPage: 10
  });
  const disabled = useMemo(() => {
    if(!words) {
      return true;
    }
    return false;
  }, [words]);
  useEffect(() => {
    form.resetFields();
    getPhraseList();
  }, [phraseModalVisible]);
  useEffect(() => {
    addPhraseVisible && inputRef.current.focus({
      cursor: 'start'
    });
  }, [addPhraseVisible]);
  const { loading, data: termList, run: getPhraseList } = useRequest(fetchPhraseList, {
    manual: true
  });
  function fetchPhraseList() {
    return raysserveapi.aiWordsList({ ...searchOptions.current });
  }
  const { run: handleDebouncedList } = useDebounceFn(() => {
    getPhraseList();
  }, { wait: 500 });
  const onPageClick = ({ currentPage }) => {
    searchOptions.current.currentPage = currentPage;
    handleDebouncedList();
  };
  const tableEmpty = <div className="file-table-empty">
    <img width={120} src="https://oss.5rs.me/oss/uploadfe/png/d7c5730fae5879ea6ca1993daf83a137.png" />
    <p className="text-gray6">暂无词组</p>
  </div>;
  const handleDelete = (id) => {
    Modal.confirm({
      className: 'TermDeleteModal',
      okText: '确定移除',
      title: '删除提醒',
      centered: true,
      width: 480,
      onOk: () => raysserveapi.aiWordsDeletes([id]).then(() => {
        if((termList?.recordList || []).length <= 1) {
          searchOptions.current.currentPage = Math.max(searchOptions.current.currentPage - 1, 0);
        }
        handleDebouncedList();
      }),
      content: '删除后，所有关于该词组的配音连续将失效'
    });
  };

  const editWords = (e, row) => {
    const val = e.target.value;
    if(val && val !== row.words) {
      raysserveapi.aiWordsEdit({
        id: row.id,
        words: val
      }).then(id => {
        message.success('修改成功');
        getPhraseList();
        // setParams({ ...params });
      });
    }
    setEditRow({});
  };
  const renderTable = () => {
    let COLUMS_NEW = [...COLUMS];
    return (
      <Table
        rowKey={record => record.fileId}
        className={classNames(`peresonTermTable`)}
        columns={COLUMS_NEW}
        onChange={onPageClick}
        loading={loading}
        paginationProps={{
          showSizeChanger: false,
          showQuickJumper: false,
          hideOnSinglePage: false,
          onShowSizeChange: false,
          showTotal: (total) => `共${Math.ceil(total / searchOptions.current.numPerPage)}页${total}条`
        }}
        tableLayout="auto"
        scroll={{ y: 370 }}
        dataSource={termList?.recordList || []}
        pageBean={termList}
        locale={{
          emptyText: tableEmpty
        }}
      />
    );
  };

  const addPhraseChange = () => {
    setAddPhraseVisible(true);
  };

  const downloadFile = () => {
    const filUrl = 'https://oss.raysgo.com/oss/uploadfe/xlsx/ce4f875ea26e74d9f4d9509c0315d98d.xlsx';
    Utils.exportFile(filUrl, '有声书连读词组导入模板');
  };

  const getNum = (val) => {
    if(val > 9) {
      return val;
    } else {
      return '0' + val;
    }
  };
  const onAddWordsValuesChange = () => {
    const { words } = form.getFieldValue();
    setWords(words);
  };
  const afterCloseAddWords = () => {
    form.resetFields();
  };
  const onChangeFile = (file) => {
    setImportLoading(true);
    let formData = new FormData();
    formData.append('excelFile', file[0]);
    raysserveapi.aiWordsExport(formData).then((res) => {
      console.log('res', res);
      res = res || {};
      message.info(res.data || res.message || '导入失败');
      getPhraseList();
    }).finally(() => {
      setImportLoading(false);
    });
  };
  const renderImportBtn = (children) => {
    return (
      <DragUpload
        ref={importUpload}
        type="EXCEL"
        className="term-import-btn"
        onChange={onChangeFile}
      >
        { children }
      </DragUpload>
    );
  };
  const COLUMS = [
    setColumn('序号', 'num', {
      width: 62,
      render(value, row, index) {

        return <div>{getNum(index + 1)}</div>;
      }
    }),
    setColumn('词组', 'words', {
      width: 465,
      render: (value, row) => {
        return (<div className={`product-item product-title`}>
          {
            editRow.id === row.id ?
              <div className="title-box title-box-edit">
                <Input
                  allowClear
                  autocomplete="off"
                  defaultValue={value}
                  autoFocus
                  onBlur={(e) => editWords(e, row)}
                />
              </div> :
              <div className="title-box">
                <span id={`product-title-${row.id}`}>{value}</span>
              </div>
          }
          { editRow.id !== row.id && <span className="edit-icon" onClick={() => setEditRow(row)} /> }
        </div>

        );
      }
    }),
    setColumn('操作', 'title5', {
      width: 104,
      dataIndex: '',
      key: 'title5',
      render: (value, row) => {
        return (
          <Space size="middle" className="oprations-btn text-primary">
            <a className="text-primary-btn" onClick={() => handleDelete(row.id)}>
              <i className="ic ic-delete ic-hidden" />
              <span className="text-cell">删除</span>
            </a>
          </Space>
        );
      }
    })
  ];

  async function validationWords(rule, value) {
    let wordsArr = value && value.split('\n')?.filter(item => item);
    if(!value?.trim()) {
      throw new Error('请输入名词');
    } else if(!/^[\u4e00-\u9fa5\n]+$/.test(value)) {
      throw new Error('输入的词组只能是汉字,多个请用换行符隔开');
    } else if(wordsArr.includes('')) {
      throw new Error('输入的词组最多用一个回车隔开');
    } else if(new Set(wordsArr).size !== wordsArr.length) {
      // throw new Error('输入的词组重复');
    } else if(wordsArr.some(item => item.length < 2)) {
      throw new Error('输入的词组至少2个汉字');
    }
  }
  return <div>
    <Modal
      className="PhraseModal"
      title={<div className="PhraseModal-title-subtitle">
        <div className="title">连读词库</div>
        <div className="subtitle">应用于所有的配音作品，设置新连读的词将会自动收录</div>
      </div>}
      width={680}
      open={phraseModalVisible}
      footer={null}
      onCancel={changePhraseModalVisible}
    >
      <div className="phraseModal-content">
        <div className="peresonTerm-content-view">
          <div size={12} className="peresonTerm-content-head">
            <Button type="primary" onClick={addPhraseChange}>
              <i className="ic ic-add" />
              <span>添加词组</span>
            </Button>
            { renderImportBtn(<div className={classNames('btn', { 'disabled': importLoading })}>
              <i className="ic ic-daoru" />
              {importLoading ? '导入中...' : '导入词组'}
              <div className="import-notice">
                <Tooltip overlayClassName="phraseModal-content-notice" placement="bottom" title="1.文件格式和内容必须与模版一致 2.一次最多导入100条数据">
                  <i className="ic ic-Union1" />
                </Tooltip></div></div>) }
            {/* <div className="import-notice">
              <Tooltip overlayClassName="phraseModal-content-notice" placement="bottom" title="1.文件格式和内容必须与模版一致 2.一次最多导入100条数据">
                <i className="ic ic-Union1" />
              </Tooltip></div> */}
            {/* <div className="btn" onClick={downloadFile}><i className="ic ic-a-file-copy3" />下载模板</div> */}
            <Button type="" onClick={downloadFile}><i className="ic ic-a-file-copy3" />下载模板</Button>
          </div>
          {
            termList?.recordList?.length ? renderTable() : tableEmpty
          }
        </div>
      </div>
    </Modal>
    <Modal
      // title="添加词组"
      title={<div>
        <div>添加词组</div>
        <div className="subtitle">支持批量添加，按回车键新增</div>
      </div>}
      className="AddWords-modal"
      open={addPhraseVisible}
      footer={null}
      width={520}
      onCancel={() => setAddPhraseVisible(false)}
      mask={false}
      afterClose={afterCloseAddWords}
      maskClosable={false}
    >
      <div>
        <Form
          form={form}
          className="content"
          onFinish={(e) => {
            let wordsArr = e?.words?.split('\n');
            let wordsParams = Array.from(new Set(wordsArr)).filter(item => item);
            raysserveapi.aiWordsBatchAdd(wordsParams).then(res => {
              message.success('添加成功');
              setAddPhraseVisible(false);
              getPhraseList();
            });
          }}
          onValuesChange={onAddWordsValuesChange}
        >
          <Form.Item
            label=""
            name="words"
            validateTrigger="onBlur"
            rules={[
              {
                required: true,
                message: ''
              },
              { validator: validationWords }
            ]}
          >
            <Input.TextArea ref={inputRef} style={{ maxHeight: 200, minHeight: 100, resize: 'none' }} autoSize={true} className="input-wrap" placeholder="请输入词组，按回车键新增" />
          </Form.Item>
          <div className="footer-btns">
            <Button className={`${disabled ? 'disabled' : ''}`} size="large" style={{ fontSize: 14 }} type="primary" htmlType="submit" block>添加</Button>
          </div>
        </Form>
      </div>
    </Modal>
  </div>;
}
